export default [
  {
    path: '/campaigns',
    name: 'campaigns',
    component: () => import('@/views/Campaign/campaign-list/CampaignsList.vue'),
    meta: {
      pageTitle: 'List All Campaigns',
      breadcrumb: [
        {
          text: 'Campaigns',
          active: true,
        },
      ],
    },
  },
]
